export default {
  steps: {
    0: {
      title: 'Devenez un habitué',
      description: 'Consultez votre historique et recommandez en un seul clic.',
    },
    1: {
      title: 'Gagnez des récompenses',
      description: 'Suivez vos points et échangez vos récompenses depuis votre portefeuille.',
    },
    2: {
      title: "Commandez à l'avance",
      description: 'Trouvez le restaurant le plus proche et commandez plus vite que jamais.',
    },
  },
  buttons: {
    skip: 'Ignorer',
  },
};
